/** Canonical external URLs for the Oxen Flow marketing site. */

export const APP_STORE_URL =
  'https://apps.apple.com/us/app/oxen-flow/id6502561067';

/** Public FYEO audit (Aureus Ox / Oxen Flow v1.0). */
export const FYEO_AUDIT_URL =
  'https://github.com/fyeo-io/public-audit-reports/blob/main/Code%20Audit%20Reports/2024/Aureus%20OX/Aureus%20Ox%20-%20Security%20Code%20Review%20Aureus%20Ox%20v1.0_public.pdf';

export const TUTORIALS_URL =
  'https://youtube.com/playlist?list=PLb5XQCI5pUv0TSSe5SCP3d0UkUED8wCMT&si=-mxbcjq38uWHyZp1';

export const AUREUS_OX_URL = 'https://aureusox.com';

export const SITE_ORIGIN = 'https://oxenflow.io';
